<template>
  <div class="Tooltip">
    <div class="Tooltip__content" :class="[this.positionClass, this.slotClass]" :data-tooltip="text">
      <span v-if="!this.$slots.default">?</span>
      <slot />
      <span class="sr-only">{{ text }}</span>
    </div>
  </div>
</template>

<script>

export default {

  name: 'tooltip',

  props: {
    text: {
      type: String
    },
    position: {
      type: String,
      default: 'right'
    }
  },

  computed: {
    positionClass () {
      return `Tooltip__content--pos-${this.position}`
    },
    slotClass () {
      return this.$slots.default ? 'tooltip__content--slot' : null
    }
  }

}
</script>

<style lang="scss">
  @import '../../scss/_variables.scss';
  @import './tooltip.scss';
</style>



// WEBPACK FOOTER //
// src/components/Tooltip/tooltip.vue